import { useContext, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useField } from 'formik';

import {
  universalReferenceActions,
  RefValueItemInterface,
} from '../../../universal-reference/store/universalReferenceStore';
import { ChoiceCard, ChoiceGrid } from '../ui';
import { FormContext } from '../forms/utils';

interface RefValueBoxSelectorProps {
  name: string
  dataTitle?: string
  dataValue?: string
  label?: string
  refId: number | string
  int1?: number | string
  filterKey?: unknown[]
  // фильтр по определённым ключам, которые нужно показать
  excludeKey?: unknown[]
  // фильтр по ключам, которые надо исключить
  sortFromBD?: boolean
  // сортировка по порядку в БД
  type?: string
}

// Выбор значения справочника плитками (ChoiceCard/ChoiceGrid из core/components/ui,
// бывш. service-box). Formik-поле: значение — id выбранного значения справочника
const RefValueBoxSelector = (props: RefValueBoxSelectorProps) => {

  const {
    refId,
    int1,
    filterKey,
    excludeKey,
    sortFromBD = false, // сортировка по порядку в БД
    name,
    label,
    type,
  } = props;

  const [localValues, setLocalValues] = useState<RefValueItemInterface[]>([]);

  const [field, meta] = useField(props);

  // @ts-ignore
  const { setFieldValue, values, submitCount } = useContext(FormContext);
  const hasError = !isEmpty(meta.error)
      && ((meta.touched && (field.value !== undefined)) || (submitCount > 0));

  // фильтранём список значений, если заданы фильтры в параметрах.
  // Копия обязательна: sortFromBD сортирует массив, а localValues — стейт
  let filteredValues = [...localValues];
  if (int1) {
    filteredValues = filteredValues.filter(v => String(v.int1) === String(int1));
  }
  if (filterKey) {
    filteredValues = filteredValues.filter(v => filterKey.find(k => v.id === k));
  }
  if (excludeKey) {
    filteredValues = filteredValues.filter(v => !(excludeKey.find(k => v.id === k)));
  }
  if (sortFromBD) {
    filteredValues.sort((a, b) => ((a.sort as number) ?? 0) - ((b.sort as number) ?? 0));
  }

  useEffect(() => {
    let isSubscribed = true;

    // экшен стора кэширует значения по refId на сессию — повторные mount'ы идут без запроса
    universalReferenceActions.getRefValues(refId)
      .then((refValues) => isSubscribed && setLocalValues(refValues));

    return () => { isSubscribed = false; };
  }, [refId]);

  return (

    <div>
      { label && <small className='form-text text-muted d-block mb-1'>{ label }</small> }
      <ChoiceGrid columns='auto' className='mb-2'>
        { filteredValues.map( v => {
          return (
            <ChoiceCard
              key = { v.id }
              variant='compact'
              title={ v.name }
              selected={ values?.[name] === v.id }
              onClick={ () => { setFieldValue(name, v.id); } }
            />
          )
        }
        ) }
      </ChoiceGrid>
      { hasError && (type !== 'hidden') && (
        <small className='form-text text-danger'>
          { meta.error ?? '' }
        </small>
      ) }
    </div>
  );
};

export default RefValueBoxSelector;
